import { createSelector } from 'reselect';

const carriersState = (state) => state.carriers;

export const verifiedAddress = createSelector([carriersState], (carriers) =>
  carriers.get('verifiedAddress'),
);
